




































































































import Vue from 'vue'
import {
  Component, Prop, Emit,
} from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue'
import MainButton from '@/shared/buttons/main-button.component.vue';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import ContractList from '@/domain/contract/entity/contract-list.entity';
import ModalOptions from '@/shared/modal/modal-options.entity';
import Header from './header-modal-contract.json'

@Component({
  components: {
    ModalComponent,
    VbTooltipSlot,
    MainButton,
    ModalWarning,
  },
})
export default class ConnectContractToContractGroup extends Vue {
  @Prop({ required: true })
  show!: boolean;

  @Prop({
    required: true,
  })
  contracts!: ContractList[];

  @Prop({
    required: true,
  })
  isAdministrator!: boolean;

  @Prop({
    required: true,
  })
  selectedAllContracts: boolean = false;

  @Prop()
  groupName!: string;

  header: any = Header;

  warningModal: boolean = false;

  warningMessage: string = '';

  loading: boolean = false;

  @Emit('cancel')
  cancel(): void {}

  get options(): ModalOptions {
    return {
      title: `Contratos Vinculados ao Grupo ${this.groupName}`,
      titleAlign: 'center',
      showClose: true,
      showCancel: true,
      labelCancel: 'Fechar',
      width: 1000,
      persistent: true,
    }
  }

  get totalSelected(): number {
    return this.contracts.filter((item: ContractList) => item.selected).length;
  }

  updateSelectedAllContract() {
    this.contracts.forEach((item: ContractList) => {
      item.selected = this.selectedAllContracts;
    });
  }

  openWarningModal(): void {
    this.warningModal = true;
    this.warningMessage = 'Deseja realmente <strong style="color: orange">desvíncular</strong> os contratos selecionados? '
    + 'Ao clicar no botão Sim, as alterações serão imediatamente realizadas.';
  }

  confirmUnbindAllSelected(): void {
    this.loading = true;
    const listContractsId = this.contracts.filter((item: ContractList) => item.selected)
      .map((it) => it.id);
    this.warningModal = false;
    this.$emit('unbindContracts', listContractsId);
    this.cancel();
    this.loading = false;
  }
}
